import { Button, Modal, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/componentsIndex";
import { ShowContext } from "../../context/Context";
import { useCallback, useContext, useEffect } from "react";
// import AuthModal from '../../components/authModal/AuthModal';
import Usercam from "../../components/Usercam/Usercam";
import "./launcher.css";

const Launcher = () => {
  const navigate = useNavigate();
  const ctx = useContext(ShowContext);

  useEffect(() => {
    ctx.setShow(false);
  }, [ctx]);

  const handleOk = useCallback(() => {
    ctx.setIsModalOpen(false);
  }, [ctx]);
  const handleCancel = useCallback(() => {
    ctx.setIsModalOpen(false);
  }, [ctx]);

  return (
    <>
      <Header ButtonHide="hide" />
      <div className="launcherContainer">
        {/* <Usercam/> */}
        <div className="button_container">
          <Space wrap>
            <Button onClick={() => navigate("/patientViewer")} type="primary">
              Patient Viewer
            </Button>
            <Button onClick={() => ctx.showModal()} type="primary">
              Login Using face
            </Button>
            <Button onClick={() => navigate("/register")} type="primary">
              Register Your face
            </Button>
          </Space>

          <Modal
            title="Login via face"
            open={ctx.isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <Usercam />
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Launcher;
